import { validate as validateEmail } from "email-validator";
import checkIp from "is-ip";

export function validIp(v: string) {
  return checkIp(v) || "Formato de IP no válido";
}

export function fieldRequired(s: string) {
  return (v: string | undefined) => !!v || `${s} es requerido`;
}

export function validEmail() {
  return (v: string) => validateEmail(v) || "E-mail no es válido";
}

export function validFormat(re: RegExp, name: string, trim?: boolean) {
  return (v: string) =>
    (!!v && (!trim || v.trim() !== "") && v !== "" && re.test(v)) ||
    `Formato de ${name} no válido`;
}
